import React, { useEffect, useState } from "react";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ModalZoom from "../../preview/modalZoom";
import NonePreview from "../../documentDetails/noPreview";
import { Modal } from "@ts-digital/vrc";
import { useSelector } from "react-redux";

const PreviewDeadlines = props => {
  const {
    changePreview,
    downloadDocument,
    downloadLoading,
    isLoadingPreview,
    previewIndex
  } = props;

  const detail = useSelector(state => state.deadlinesDetail.subjective);

  // const [counterPage, setCounterPage] = useState(0); // tiene ordine del numero pagina
  const [, setCurrentFileName] = useState("");
  // const [effectivePageNumber, setEffectivePageNumber] = useState(0); // il numero di pagina effettivo da richiedere all'api
  // const [lastPageNumb, setLastPageNumb] = useState(1); // tengo traccia del numero di paginazione scelto dall'utente
  const [totalPages, setTotalPages] = useState(0);
  const [modalZoom, setModalZoom] = useState(false);
  const [modalZoomImg, setModalZoomImg] = useState("");
  const [modalZoomPage, setModalZoomPage] = useState(1);
  // const [paginationPage, setPaginationPage] = useState(1);
  const [oldImgSrc, setOldImgSrc] = useState(null);
  const [, setLockPreview] = useState(false);

  /* static getDerivedStateFromProps(nextProps, prevState) {
    let totalPagesSum = 0;
    let fileName = "";
    let oldImgSrc;
    if (nextProps.detail && nextProps.detail.attachmentsDetail) {
      totalPagesSum = nextProps.detail.attachmentsDetail[
        prevState.attachmentIndex
      ]
        ? nextProps.detail.attachmentsDetail[prevState.attachmentIndex]
            .numberOfPages
        : 0;
      fileName = nextProps.detail.attachmentsDetail[prevState.attachmentIndex]
        ? nextProps.detail.attachmentsDetail[prevState.attachmentIndex].fileName
        : "";
      oldImgSrc = nextProps.detail.attachmentsDetail[nextProps.previewIndex].content !== undefined
        ? nextProps.detail.attachmentsDetail[nextProps.previewIndex].content
        : nextProps.detail.preview !== undefined && nextProps.detail.preview !== null ? nextProps.detail.preview
        : null;
    }
    return {
      currentFileName: fileName,
      totalPages: totalPagesSum,
      oldImgSrc: oldImgSrc
    };
  }*/

  useEffect(() => {
    if (detail.attachmentsDetail) {
      changePreview(detail.attachments[previewIndex].id, 1);
    }
  }, [previewIndex]);

  useEffect(() => {
    let totalPagesSum = 0;
    if (detail && detail.attachmentsDetail) {
      totalPagesSum = detail.attachmentsDetail[previewIndex]
        ? detail.attachmentsDetail[previewIndex].numberOfPages
        : 0;
    }
    setTotalPages(totalPagesSum);
  }, [detail, detail.attachmentsDetail]);

  useEffect(() => {
    let fileName = "";
    if (detail && detail.attachmentsDetail) {
      fileName = detail.attachmentsDetail[previewIndex]
        ? detail.attachmentsDetail[previewIndex].fileName
        : "";
    }
    setCurrentFileName(fileName);
  }, [detail, detail.attachmentsDetail]);

  useEffect(() => {
    let oldImgSrc;
    if (detail && detail.attachmentsDetail) {
      oldImgSrc =
        detail.attachmentsDetail[previewIndex].content !== undefined
          ? detail.attachmentsDetail[previewIndex].content
          : detail.preview !== undefined && detail.preview !== null
            ? detail.preview
            : null;
    }
    setOldImgSrc(oldImgSrc);
  }, [detail, detail.attachmentsDetail]);

  useEffect(() => {
    // Elimino margini Modale non sovrapponibile lo style per problemi di className random
    let nearestElem = document.getElementsByClassName("openWindowContainer");
    if (nearestElem && nearestElem.length > 0) {
      nearestElem[0].parentNode.style.maxHeight = "calc(100vh - 170px)";
      nearestElem[0].parentNode.parentNode.style.marginTop = "40px";
    }
  }, [modalZoom, modalZoomImg, modalZoomPage]);

  /* const changePageAmongPreview = pageNumber => {
    let whatAttachmentIdx = pageNumber - 1; // tengo traccia del indice dell attachment a cui riferisce la pagina
    setAttachmentIndex(whatAttachmentIdx);
    setCounterPage(pageNumber);
    setLastPageNumb(pageNumber);
    setLockPreview(false);
    setModalZoom(1);
    changePreview(detail.attachments[whatAttachmentIdx].id, 1);
  };*/

  const addPageModalZoom = () => {
    if (isLoadingPreview || modalZoomPage === totalPages) {
      return;
    }
    setLockPreview(true);
    changePreview(detail.attachments[previewIndex].id, modalZoomPage + 1);
    setModalZoomPage(modalZoomPage + 1);
  };

  const downloadDocs = () => {
    downloadDocument(previewIndex);
  };

  const renderModalZoom = () => {
    if (modalZoom) {
      return (
        <Modal
          visible={modalZoom}
          title={"Anteprima documento"}
          onClose={e => {
            setModalZoom(false);
            setModalZoomImg("");
            setModalZoomPage(1);
            document.getElementsByTagName("body")[0].style.overflow = "auto";
          }}
          type="primary"
          outsideClosable={false}
        >
          <ModalZoom
            downloadDocument={downloadDocs}
            imgSrc={
              detail && detail.preview
                ? `data:image/jpeg;base64,${detail.preview}`
                : null
            }
            onClose={() => {
              changePreview(detail.attachments[previewIndex].id, 1);
              setModalZoom(false);
              setModalZoomImg("");
              setModalZoomPage(1);
            }}
            openPreviewPage={addPageModalZoom}
            pagesTotal={totalPages}
            isLoading={isLoadingPreview}
            waitForLoading={true}
            transparentBackground={true}
          />
        </Modal>
      );
    }
    return undefined;
  };

  let imgSrc = oldImgSrc ? `data:image/jpeg;base64,${oldImgSrc}` : null;
  return (
    <>
      {detail.attachmentsDetail !== undefined && (
        <div style={{ flex: "1 1 auto", margin: "16px" }}>
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <div style={{ flex: "1 0 auto" }}>
              <div style={{ display: "flex" }}>
                {detail.attachmentsDetail && (
                  <Tooltip
                    placement="topLeft"
                    title="Download documento"
                    className="gs-deadlines-detail-download"
                    onClick={downloadDocs}
                  >
                    <FontAwesomeIcon
                      icon={["far", "file-download"]}
                      style={{
                        fontSize: 22,
                        color: "#0090d1",
                        cursor: "pointer"
                      }}
                    />
                  </Tooltip>
                )}
                {downloadLoading ? (
                  <div style={{ flex: "0 0 auto", marginLeft: 10 }}>
                    <FontAwesomeIcon
                      icon={["far", "circle-notch"]}
                      style={{ fontSize: 22, color: "#0090d1" }}
                      spin
                    />{" "}
                  </div>
                ) : null}
              </div>
            </div>
            <div style={{ display: "flex", marginRight: "10px" }}>
              <div
                id="fileNameCurrent"
                style={{ flex: "1 0 auto", marginRight: "16px" }}
              >
                <span style={{ marginRight: 20 }}>
                  {detail.attachmentsDetail &&
                    `${
                      detail.attachmentsDetail[previewIndex].subTitle !== ""
                        ? detail.attachmentsDetail[previewIndex].subTitle
                        : detail.attachmentsDetail[previewIndex].fileName
                    }`}
                </span>
              </div>
            </div>
          </div>
          {imgSrc ? (
            <div className="fatturaPreviewContainer">
              <img
                className={"fatturaPreview"}
                style={{ width: "100%" }}
                src={imgSrc}
                alt={"Preview Documento"}
              />
              <div
                className="overlay gs-deadlines-detail-preview"
                onClick={() => {
                  document.body.className =
                    document.body.className + " overflowHidden";
                  setModalZoom(true);
                }}
              >
                <FontAwesomeIcon
                  className="icon"
                  icon={["fas", "search"]}
                  style={{ fontSize: "64px", color: "#fff" }}
                />
              </div>
            </div>
          ) : isLoadingPreview ? (
            <div
              style={{
                display: "flex",
                width: "100%",
                height: "calc(100vh - 64px - 80px - 16px)",
                margin: "auto"
              }}
            >
              <div style={{ flex: "0 0 auto", margin: "auto" }}>
                <FontAwesomeIcon
                  icon={["far", "circle-notch"]}
                  style={{ fontSize: "50px", color: "#0090d1" }}
                  spin
                />
              </div>
            </div>
          ) : (
            <NonePreview />
          )}
          {renderModalZoom()}
        </div>
      )}
    </>
  );
};

export default PreviewDeadlines;
